export class CC3ConfigAPIModel {

  ScoreConfigGridAPI: string = "";
  CC3ScoreConfigByID: any;
  ScoreConfigAPI: any;
  GetjournalsListApi: string;
  GetConfigjournalsListApi: string;
  ConfigGridAPI: string = "";
  ConfigCategoryGridAPI: string = "";
  PublisherIDAPI: string = "";
  CC3ConfigByID: any;
  UpdateConfigAPI: any;
  GetCategoryTableId: any;

}
